import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Labresultmst, LabresultmstData } from '../../../interfaces/masters/labresultmst';
import { LabresultmstApi } from '../api/labresultmst.api';

@Injectable()
export class LabresultmstService extends LabresultmstData{

  constructor(private api: LabresultmstApi) {
    super();
  }
  list(url: string): Observable<Labresultmst[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Labresultmst>{
      return this.api.getById(url);
  }

  create(url: string, data:Labresultmst): Observable<Labresultmst[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:Labresultmst): Observable<Labresultmst> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
